import { requestWrapper } from '@/utils/axiosInstance';

const API_DEVELOPER = `${process.env.VUE_APP_API_MAIN}/developer`;

export default {
  async search(query) {
    return await requestWrapper(API_DEVELOPER, 'GET', '/search_classifiers_classes', query);
  },
};
